import { ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { storage } from '../firebase/config';

// Upload image to Firebase Storage
export const uploadImage = async (file, folder = 'images') => {
    try {
        // Create unique filename
        const timestamp = Date.now();
        const filename = `${folder}/${timestamp}-${file.name}`;

        // Create storage reference
        const storageRef = ref(storage, filename);

        // Upload file
        const snapshot = await uploadBytes(storageRef, file);

        // Get download URL
        const downloadURL = await getDownloadURL(snapshot.ref);

        return {
            url: downloadURL,
            path: filename,
            name: file.name
        };
    } catch (error) {
        console.error('Error uploading image:', error);
        throw error;
    }
};

// Delete image from Firebase Storage
export const deleteImage = async (imagePath) => {
    try {
        const imageRef = ref(storage, imagePath);
        await deleteObject(imageRef);
        console.log('Image deleted successfully');
    } catch (error) {
        console.error('Error deleting image:', error);
        throw error;
    }
};

// Validate image file
export const validateImage = (file) => {
    // Check file type
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
    if (!allowedTypes.includes(file.type)) {
        throw new Error('Please select a valid image file (JPEG, PNG, or WebP)');
    }

    // Check file size (10MB limit - increased from 5MB)
    const maxSize = 10 * 1024 * 1024; // 10MB in bytes
    if (file.size > maxSize) {
        throw new Error('Image size must be less than 10MB');
    }

    return true;
};

// Resize image before upload (with improved quality)
export const resizeImage = (file, maxWidth = 1920, maxHeight = 1080, quality = 0.95) => {
    return new Promise((resolve) => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        const img = new Image();

        img.onload = () => {
            // Calculate new dimensions
            let { width, height } = img;

            // Only resize if image is larger than max dimensions
            if (width > maxWidth || height > maxHeight) {
                if (width > height) {
                    if (width > maxWidth) {
                        height = (height * maxWidth) / width;
                        width = maxWidth;
                    }
                } else {
                    if (height > maxHeight) {
                        width = (width * maxHeight) / height;
                        height = maxHeight;
                    }
                }
            }

            // Set canvas dimensions
            canvas.width = width;
            canvas.height = height;

            // Enable high-quality rendering
            ctx.imageSmoothingEnabled = true;
            ctx.imageSmoothingQuality = 'high';

            // Draw and compress
            ctx.drawImage(img, 0, 0, width, height);

            // Use higher quality for final output
            canvas.toBlob(resolve, file.type, quality);
        };

        img.src = URL.createObjectURL(file);
    });
};